export const getEfficiencyColor = (efficiency) => {
  if (efficiency > 110) return 'text-red-600 dark:text-red-400';
  if (efficiency > 90) return 'text-yellow-600 dark:text-yellow-400';
  return 'text-green-600 dark:text-green-400';
};

export const getVarianceColor = (variance) => {
  if (variance > 5) return 'text-red-600 dark:text-red-400';
  if (variance > 0) return 'text-yellow-600 dark:text-yellow-400';
  if (variance < -5) return 'text-green-600 dark:text-green-400';
  return 'text-gray-600 dark:text-slate-400';
};

export const getIssueTypeBadgeClasses = (type) => {
  if (!type || typeof type !== 'string') return 'bg-gray-50 dark:bg-slate-700 text-gray-700 dark:text-slate-200 border-gray-200 dark:border-white/10';
  
  const normalizedType = type.trim().toLowerCase();
  switch (normalizedType) {
    case 'story':
      return 'bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-300 border-green-200 dark:border-green-800';
    case 'task':
      return 'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border-blue-200 dark:border-blue-800';
    case 'bug':
      return 'bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300 border-red-200 dark:border-red-800';
    default:
      return 'bg-gray-50 dark:bg-slate-700 text-gray-700 dark:text-slate-200 border-gray-200 dark:border-white/10';
  }
};

export const getStatusColor = (status) => {
  if (!status || typeof status !== 'string') return 'bg-gray-100 dark:bg-slate-700 text-gray-800 dark:text-slate-200';
  
  const normalizedStatus = status.trim().toLowerCase();
  const statusColors = {
    'to do': 'bg-gray-100 dark:bg-slate-700 text-gray-800 dark:text-slate-200',
    'in progress': 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300',
    'done': 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300',
    'blocked': 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300',
    'pr review': 'bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300',
    'review': 'bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300',
    'code review': 'bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300',
    'testing': 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300',
    'closed': 'bg-gray-100 dark:bg-slate-700 text-gray-800 dark:text-slate-200',
    'qa': 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300',
    'ready for release': 'bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300',
  };
  
  return statusColors[normalizedStatus] || 'bg-gray-100 dark:bg-slate-700 text-gray-800 dark:text-slate-200';
};

